module.exports = __webpack_public_path__ + "img/fw-pic1.b5bd97b1.jpg";